/* eslint-disable */
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import {
  approveEsfaCode,
  esfaCodesMasterList,
} from "../../Redux/Actions/MastersApprovalActions";
import { OverlayTrigger } from "react-bootstrap";
import Swal from "sweetalert2";

const ESFACodeMaster = ({ selectedTab, ApproveTooltip, DeleteTooltip }) => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortColumnDir, setSortColumnDir] = useState(null);

  const loading = useSelector(
    (state) => state.MastersApproval.esfaCodesLoading
  );
  const esfaCodeMasterList = useSelector(
    (state) => state.MastersApproval.esfaCodesMasterList
  );
  const noOfRecords = useSelector(
    (state) => state.MastersApproval.noOfRecordsEsfaCodes
  );

  const getAllESFACodesMasterList = (
    page_number,
    page_size,
    sort_column_name,
    sort_column_dir,
    search_text
  ) => {
    const data = {
      page_number: page_number,
      page_size: page_size,
      sort_column_name: !!sort_column_name ? sort_column_name : null,
      sort_column_dir: !!sort_column_dir ? sort_column_dir : null,
      search_text: !!search_text ? search_text : null,
    };
    dispatch(esfaCodesMasterList(data));
  };

  const handleSort = (column, sortDirection) => {
    if (Object.keys(column).length !== 0 && !!sortDirection) {
      setSortColumn(column.sortField);
      setSortColumnDir(sortDirection);
      getAllESFACodesMasterList(
        1,
        perPage,
        column.sortField,
        sortDirection,
        searchText
      );
    }
  };

  const handlePageChange = (page) => {
    setPage(page);
    getAllESFACodesMasterList(
      page,
      perPage,
      sortColumn,
      sortColumnDir,
      searchText
    );
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setPage(page);
    getAllESFACodesMasterList(
      page,
      newPerPage,
      sortColumn,
      sortColumnDir,
      searchText
    );
  };

  const approveEsfaCodesMaster = async (id, is_delete) => {
    const data = {
      id: id,
      is_delete: is_delete,
    };
    Swal.fire({
      title: "Are you sure?",
      html: `You want to ${is_delete ? "delete" : "approve"}!`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#000000",
      cancelButtonColor: "#dd3333",
      confirmButtonText: is_delete ? "Delete" : "Approve",
      customClass: {
        confirmButton: 'confirm-button-swal'
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await dispatch(approveEsfaCode(data));
        if (res.payload.result > 0) {
          getAllESFACodesMasterList(page, perPage, null, null, null);
          Swal.fire({
            title: res?.payload?.message,
            confirmButtonColor: "#000000",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: 'confirm-button-swal'
            }
          })
        } else {
          Swal.fire({
            title: res?.payload?.message,
            confirmButtonColor: "#000000",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: 'confirm-button-swal'
            }
          })
        }
      }
    });
  };

  useEffect(() => {
    if (!!selectedTab && selectedTab === "esfacode") {
      getAllESFACodesMasterList(page, perPage, null, null, searchText);
    }
  }, [selectedTab, searchText]);

  const customStylesDataTable = {
    headCells: {
      style: {
        fontSize: "16px",
        fontWeight: "Bold",
      },
    },
  };

  const columns = [
    {
      name: "DesciptionLDH",
      selector: (row) => row.desciptionLDH,
      sortable: true,
      sortField: "DesciptionLDH",
      grow: 2,
    },
    {
      name: "Type",
      selector: (row) => row.type,
      sortable: true,
      sortField: "Type",
    },
    {
      name: "ESFACode",
      selector: (row) => row.esfaCode,
      sortable: true,
      sortField: "ESFACode",
      grow: 2,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
      sortField: "Description",
    },
    {
      name: "Length",
      selector: (row) => row.length,
      sortable: true,
      sortField: "Length",
      grow: 2,
    },
    {
      name: "Depth",
      selector: (row) => row.depth,
      sortable: true,
      sortField: "Depth",
    },
    {
      name: "Height",
      selector: (row) => row.height,
      sortable: true,
      sortField: "Height",
      grow: 2,
    },
    {
      name: "RangeTolerance",
      selector: (row) => row.rangeTolerance,
      sortable: true,
      sortField: "RangeTolerance",
      width: "150px",
    },
    {
      name: "Qualifier",
      selector: (row) => row.qualifier,
      sortable: true,
      sortField: "Qualifier",
      grow: 2,
    },
    {
      name: "Comments",
      selector: (row) => row.comments,
      sortable: true,
      sortField: "Comments",
    },
    {
      name: "AdditionalComments",
      selector: (row) => row.additionalComments,
      sortable: true,
      sortField: "AdditionalComments",
      grow: 2,
      width: "170px",
    },
    {
      name: "Checked",
      selector: (row) => row.checked,
      sortable: true,
      sortField: "Checked",
    },
    {
      name: "Action",
      cell: (row) => (
        <>
        <div className={`actions`}>
          <OverlayTrigger placement="top" overlay={ApproveTooltip}>
            <button
              className="btn btn-sm bg-success-subtle"
              onClick={() => approveEsfaCodesMaster(row.id, false)}
            >
              <i className="bi bi-check2-circle"></i>
            </button>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={DeleteTooltip}>
            <button
              className="btn btn-sm bg-danger-subtle ms-2"
              onClick={() => approveEsfaCodesMaster(row.id, true)}
            >
              <i className="bi bi-trash"></i>
            </button>
          </OverlayTrigger>
          </div>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div>
      <DataTable
        columns={columns}
        data={esfaCodeMasterList}
        className="table table-bordered table-striped"
        filterServer={true}
        pagination
        paginationServer
        paginationTotalRows={noOfRecords}
        progressPending={loading}
        subHeader
        subHeaderComponent={
          <div className="col-md-2">
            <input
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search"
              className="form form-control"
            />
          </div>
        }
        progressComponent={
          <div style={{ padding: "100px" }}>
            <div className="spinner-border" role="status"></div>
          </div>
        }
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        sortServer
        onSort={handleSort}
        highlightOnHover
        searchableRows={true}
        customStyles={customStylesDataTable}
      />
    </div>
  );
};

export default ESFACodeMaster;
